<template>
  <Panel class="ship-order-itinerary-panel loading">
    <template #header>
      <div class="ship-order-itinerary-panel-header">
        <span class="flex">
          {{ t('shipments.shipments') }}
          #
          <Skeleton v-for="i in 4" :key="i" height="1rem" width="1ch" />
        </span>

        <RygenChip :label="t('common.loading')" />
      </div>
    </template>

    <template #default>
      <dl class="info">
        <div class="row-group">
          <div class="row">
            <dt class="w-5">{{ t('carriers.carriers') }}</dt>
            <dd class="w-7">
              <Skeleton height="1rem" />
            </dd>
          </div>

          <div class="row">
            <dt class="w-5">{{ t('common.proNum') }}</dt>
            <dd class="w-7">
              <Skeleton height="1rem" />
            </dd>
          </div>
        </div>

        <div class="row-group">
          <div class="row">
            <dt class="w-5">{{ t('shipments.modes') }}</dt>
            <dd class="w-7">
              <Skeleton height="1rem" />
            </dd>
          </div>

          <div class="row">
            <dt class="w-5">{{ t('shipments.services') }}</dt>
            <dd class="w-7">
              <Skeleton height="1rem" />
            </dd>
          </div>

          <div class="row">
            <dt class="w-5">{{ t('common.mileage') }}</dt>
            <dd class="w-7">
              <Skeleton height="1rem" />
            </dd>
          </div>
        </div>
      </dl>

      <div class="locations">
        <KeyValuePair :label="t('orders.origin')" class="h-auto">
          <template #value>
            <Skeleton height="6rem" width="10rem" />
          </template>
        </KeyValuePair>

        <i aria-hidden="true" class="pi pi-arrow-right text-gray-dark" />

        <KeyValuePair :label="t('orders.destination')" class="h-auto">
          <template #value>
            <Skeleton height="6rem" width="10rem" />
          </template>
        </KeyValuePair>
      </div>
    </template>
  </Panel>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';
import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';
import Panel from 'primevue/panel';
import Skeleton from 'primevue/skeleton';

const { t } = useI18n();
</script>

<style>
/*
Shares styles with `ShipOrderItineraryPanel`. Everything below is overrides
specifically for the loading state
*/
.ship-order-itinerary-panel.p-panel.loading {
  .p-panel-content {
    .info {
      --p-skeleton-background: var(--p-gray-300);

      .row {
        & + .row {
          margin-top: var(--sp-2);
        }
      }
    }
  }
}
</style>
